import React from "react";
import { motion } from "framer-motion";
import { cn } from "../lib/utils";
import { logos } from "../data/mock";
import { useTheme } from "../hooks/useTheme";

export const LampContainer = ({
  children,
  className,
}) => {
  return (
    <div
      className={cn(
        "relative flex h-[100vh] flex-col items-center justify-center overflow-hidden bg-slate-50 dark:bg-[#030B1A] w-full z-0",
        className
      )}
    >
      <div className="relative flex w-full flex-1 scale-y-125 items-center justify-center isolate z-0 ">
        <motion.div
          initial={{ opacity: 0.5, width: "15rem" }}
          whileInView={{ opacity: 1, width: "30rem" }}
          transition={{
            delay: 0.3,
            duration: 0.8,
            ease: "easeInOut",
          }}
          style={{
            backgroundImage: `conic-gradient(var(--conic-position), var(--tw-gradient-stops))`,
          }}
          className="absolute inset-auto right-1/2 h-56 overflow-visible w-[30rem] bg-gradient-conic from-blue-500 via-transparent to-transparent text-white [--conic-position:from_70deg_at_center_top]"
        >
          <div className="absolute w-[100%] left-0 bg-slate-50 dark:bg-[#030B1A] h-40 bottom-0 z-20 [mask-image:linear-gradient(to_top,white,transparent)] transition-colors duration-500" />
          <div className="absolute w-40 h-[100%] left-0 bg-slate-50 dark:bg-[#030B1A] bottom-0 z-20 [mask-image:linear-gradient(to_right,white,transparent)] transition-colors duration-500" />
        </motion.div>

        <motion.div
          initial={{ opacity: 0.5, width: "15rem" }}
          whileInView={{ opacity: 1, width: "30rem" }}
          transition={{
            delay: 0.3,
            duration: 0.8,
            ease: "easeInOut",
          }}
          style={{
            backgroundImage: `conic-gradient(var(--conic-position), var(--tw-gradient-stops))`,
          }}
          className="absolute inset-auto left-1/2 h-56 w-[30rem] bg-gradient-conic from-transparent via-transparent to-blue-500 text-white [--conic-position:from_290deg_at_center_top]"
        >
          <div className="absolute w-40 h-[100%] right-0 bg-slate-50 dark:bg-[#030B1A] bottom-0 z-20 [mask-image:linear-gradient(to_left,white,transparent)] transition-colors duration-500" />
          <div className="absolute w-[100%] right-0 bg-slate-50 dark:bg-[#030B1A] h-40 bottom-0 z-20 [mask-image:linear-gradient(to_top,white,transparent)] transition-colors duration-500" />
        </motion.div>

        <div className="absolute top-1/2 h-48 w-full translate-y-12 scale-x-150 bg-slate-50 dark:bg-[#030B1A] blur-2xl transition-colors duration-500"></div>
        <div className="absolute top-1/2 z-50 h-48 w-full bg-transparent opacity-10 backdrop-blur-md"></div>
        <div className="absolute inset-auto z-50 h-36 w-[28rem] -translate-y-1/2 rounded-full bg-blue-500 opacity-50 blur-3xl"></div>
        <motion.div
          initial={{ width: "8rem" }}
          whileInView={{ width: "16rem" }}
          transition={{
            delay: 0.3,
            duration: 0.8,
            ease: "easeInOut",
          }}
          className="absolute inset-auto z-30 h-36 w-64 -translate-y-[6rem] rounded-full bg-blue-400 blur-2xl"
        ></motion.div>
        <motion.div
          initial={{ width: "15rem" }}
          whileInView={{ width: "30rem" }}
          transition={{
            delay: 0.3,
            duration: 0.8,
            ease: "easeInOut",
          }}
          className="absolute inset-auto z-50 h-0.5 w-[30rem] -translate-y-[7rem] bg-blue-400 "
        ></motion.div>

        <div className="absolute inset-auto z-40 h-44 w-full -translate-y-[12.5rem] bg-slate-50 dark:bg-[#030B1A] transition-colors duration-500"></div>
      </div>

      <div className="relative z-50 flex -translate-y-80 flex-col items-center px-5">
        {children}
      </div>
    </div>
  );
};

export const ScrollLogoSection = () => {
  const { isDark } = useTheme();

  return (
    <section id="marca" className="relative bg-slate-50 dark:bg-[#030B1A]">
      <LampContainer>
        <motion.div
          initial={{ opacity: 0.5, y: 100 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{
            delay: 0.3,
            duration: 0.8,
            ease: "easeInOut",
          }}
          className="flex flex-col items-center justify-center"
        >
          <img
            src={isDark ? logos.white : logos.blue}
            alt="Movii"
            className="w-80 sm:w-96 lg:w-[480px] h-auto object-contain drop-shadow-2xl"
          />
          <p className="mt-8 text-slate-500 dark:text-white/40 text-sm sm:text-base tracking-[0.3em] uppercase font-light">
            Marketing em movimento
          </p>
        </motion.div>
      </LampContainer>
    </section>
  );
};
